import { ChakraProvider } from '@chakra-ui/react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Login from './page/login/Login';
// import Room from './page/room/Room';
import Room from './page/room/Room2';
import Test from './page/room/test';
import { HelmetProvider } from "react-helmet-async";
import WebSocketClient from './page/room/stmp';
// TODO: websocket 元件
function App() {
  const router = createBrowserRouter([
    { path: "/", element: <Login /> },
    { path: "/ws", element: <Room /> },
  ]);

  return (
    <HelmetProvider>
      <ChakraProvider>
        <RouterProvider router={router} />
      </ChakraProvider>
    </HelmetProvider>
  );
}


export default App;


// <head>
//   <link rel="icon" type="image/png" href="/path/to/favicon.png">
//   <!-- 或 -->
//   <link rel="shortcut icon" href="/path/to/favicon.ico" type="image/x-icon">
// </head>
